// Simple authentication system for admin access
const ADMIN_CREDENTIALS = {
  username: 'Admin',
  password: 'XmanAmos@1978'
};

const TOKEN_KEY = 'aiximo_admin_token';
const TOKEN_EXPIRY = 24 * 60 * 60 * 1000; // 24 hours

export const loginAdmin = async (username, password) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 500));
  
  if (username === ADMIN_CREDENTIALS.username && password === ADMIN_CREDENTIALS.password) {
    const token = generateToken();
    const tokenData = {
      token,
      expiresAt: Date.now() + TOKEN_EXPIRY,
      username
    };
    
    localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
    
    return { success: true, token };
  }
  
  return { success: false, error: 'Invalid credentials' };
};

export const logoutAdmin = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthenticated = () => {
  try {
    const tokenData = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}');
    
    if (!tokenData.token || !tokenData.expiresAt) {
      return false;
    }
    
    if (Date.now() > tokenData.expiresAt) {
      localStorage.removeItem(TOKEN_KEY);
      return false;
    }
    
    return true;
  } catch (error) {
    return false;
  }
};

export const getCurrentUser = () => {
  try {
    const tokenData = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}');
    return tokenData.username || null;
  } catch (error) {
    return null;
  }
};

const generateToken = () => {
  return btoa(Math.random().toString(36).substring(2) + Date.now().toString(36));
};

// Session management
export const extendSession = () => {
  try {
    const tokenData = JSON.parse(localStorage.getItem(TOKEN_KEY) || '{}');
    if (tokenData.token) {
      tokenData.expiresAt = Date.now() + TOKEN_EXPIRY;
      localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
      return true;
    }
  } catch (error) {
    return false;
  }
  return false;
};

// Auto-logout on inactivity
let inactivityTimer;

export const setupAutoLogout = (onLogout) => {
  const resetTimer = () => {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      logoutAdmin();
      onLogout();
    }, 30 * 60 * 1000); // 30 minutes
  };

  // Reset timer on user activity
  document.addEventListener('mousedown', resetTimer);
  document.addEventListener('keypress', resetTimer);
  document.addEventListener('scroll', resetTimer);
  
  // Initial timer
  resetTimer();
  
  // Cleanup function
  return () => {
    clearTimeout(inactivityTimer);
    document.removeEventListener('mousedown', resetTimer);
    document.removeEventListener('keypress', resetTimer);
    document.removeEventListener('scroll', resetTimer);
  };
};